import { useParams } from "react-router-dom";

import Header from "@/components/Header";
import Sidebar from "@/components/Sidebar";
import LessonHeader from "@/components/lesson/LessonHeader";
import { SidebarProvider } from "@/components/ui/sidebar";
import { COURSES } from "@/data/courseSections";

const LessonDetails = () => {
  const { courseSlug, sectionId, lessonId } = useParams();

  const course = COURSES.find((course) => course.slug === courseSlug);
  const sectionIndex = course?.course.findIndex(
    (section) => section.slug === sectionId,
  );
  if (sectionIndex < 0) {
    return null;
  }
  const section = course?.course[sectionIndex];
  const lessonIndex = section?.lessons.findIndex(
    (lesson) => lesson.slug === lessonId,
  );
  if (lessonIndex < 0) {
    return null;
  }
  const lesson = section?.lessons[lessonIndex];

  return (
    <SidebarProvider>
      <div className="min-h-screen w-full flex flex-col bg-gray-50">
        <Header />
        <div className="flex-1 flex">
          <Sidebar />
          <div className="flex-1 p-6 overflow-y-auto">
            <div className="max-w-5xl mx-auto w-full">
              <LessonHeader />
              <div className="grid gap-6">
                {/* Instructional Routines Block */}
                <div className="bg-white rounded-lg shadow-sm border border-gray-200">
                  <div className="border rounded-lg overflow-hidden">
                    <div className="bg-gray-50 px-4 py-2 border-b">
                      <h3 className="font-medium">Learning Objectives</h3>
                    </div>
                    <ul className="px-8 py-4 list-disc">
                      {lesson.objectives.map((objective) => (
                        <li key={objective}>{objective}</li>
                      ))}
                    </ul>
                  </div>
                </div>

                {/* Lesson Plan Block */}
                <div className="bg-white rounded-lg shadow-sm border border-gray-200">
                  <div className="border rounded-lg overflow-hidden">
                    <div className="bg-gray-50 px-4 py-2 border-b">
                      <h3 className="font-medium">Lesson Plan</h3>
                    </div>
                    <div className="h-[500px] overflow-hidden">
                      {/* {lesson.pdfPath && <Pdf path={lesson.pdfPath} />} */}
                      {lesson.pdfPath && (
                        <object
                          className="w-full h-full"
                          data={`${lesson.pdfPath}#view=FitH`}
                        ></object>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SidebarProvider>
  );
};

export default LessonDetails;
